import React from 'react';
import { motion } from 'framer-motion';
const STATS = [{
  label: 'Total Revenue',
  value: '$88,472'
}, {
  label: 'Total Miles',
  value: '24,261'
}, {
  label: 'Number of Loads',
  value: '41'
}, {
  label: 'Rate Per Mile',
  value: '$3.64'
}];
export function DispatchCounter() {
  return <section id="activity" className="bg-off-white pb-12 lg:pb-16 scroll-mt-24" data-id="element-135">
      <div className="container-custom" data-id="element-136">
        <div className="bg-navy rounded-sm shadow-xl border-t-4 border-amber p-8 md:p-10 -mt-8 relative z-20" data-id="element-137">
          <div className="text-center mb-8" data-id="element-138">
            <h2 className="text-2xl md:text-3xl font-black text-white tracking-tight mb-2" data-id="element-139">
              Recent Dispatch Activity
            </h2>
            <p className="text-xs md:text-sm text-off-white/60 font-bold uppercase tracking-wider" data-id="element-140">
              Last 30 Days &middot; Updated 6/10/26
            </p>
            {/* Placeholder note: Real counter code will be injected here when available */}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-141">
            {STATS.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="text-center" data-id="element-142">
                <div className="text-3xl md:text-4xl lg:text-5xl font-black text-amber mb-2 tracking-tight" data-id="element-143">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm font-bold text-off-white/70 uppercase tracking-wider" data-id="element-144">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>

          <p className="text-xs text-off-white/50 font-medium text-center max-w-2xl mx-auto mt-8 leading-relaxed" data-id="element-145">
            Recent dispatch activity. Actual results depend on equipment, lanes,
            market conditions, availability, and how you run.
          </p>
        </div>
      </div>
    </section>;
}